import React, { useCallback, useRef, useState } from 'react';
import Filter from '@/pages/dashboard/components/NewFilter';
import { FORM_MAP } from '@/pages/dashboard/pages/overview/_config/constant';
import { setBtnPointLog } from "@/pages/dashboard/utils/utils";
import { getDateDefault } from '@/pages/dashboard/utils/dateUtils';
import { formatDateFromFilterValue } from "@/pages/dashboard/utils/formatDate";
import { PC_CONSOLE_DEFAULT_FILTER_CONFIG } from "@/pages/dashboard/components/NewFilter/_config";
import { useSelector } from 'umi';

// 筛选器路径
const FILTER_PATH = 'overview/weekly';

/**
 *
 * @param props
 * @param props:filterConfirm 筛选器确认函数
 * @param props:filterReset 筛选器重置函数
 * @param props:filterInit 初始化函数，会向外部传递初始化后的筛选器值
 * @returns
 */

// daily筛选器继承逻辑
const PcConsoleWeeklyFilter = (props: any) => {
  const { filterConfirm, filterReset, filterInit, buttonLogConfig, openSticky = false, path = FILTER_PATH, children, isHaveFilterSave, timeZone = 0, config } = props;
  const {rangePickerConfig}=config;
  // const timeDiff = useRef<boolean>(false);
  const filterValueRef = useRef<any>(null); // 筛选器值，此处不用state，更新formValue同样会触发组件更新
  const seasonInfo = useSelector((state: any) =>
    // 初始可能为undefied,在此加兜底
    state?.dashboardSetting?.gameConfig?.season_info || {date: [],week: [],month: []}
  );
  // 设置inputList,和后端核对后，此次筛选器的展示都是由后端控制，配置为时间，地区，平台和语言四个筛选器
  const [inputList] = useState([
    {
      type: 'rangeWeekly',
      key: 'rangeTime',
      default: getDateDefault({timeType: 'week', timeZone, startNum: 1, endNum: 1}),
      extraShortcut: seasonInfo,
      ...rangePickerConfig
    },
  ]);

  // 私有化处理，抹平新旧筛选器的差距
  const onInit = useCallback((value, _inputList, isHaveExtendFIlter) => {
    filterValueRef.current = value;
    // todo 锁定状态下如果锁定时间跟默认时间相同，是否需要单独处理，设置diff为false？
    filterInit({
      ...(formatDateFromFilterValue(value, 'Week') || {}),
      [FORM_MAP.RANGE_TIME_DIFF]: !isHaveExtendFIlter,
      timeType: 'Week',
      rangeDateKey: 'rangeWeekly',
    });
  }, [filterInit]);

  const onConfirm = useCallback((value) => {
    filterValueRef.current = value;
    const obj: any = {
      ...(formatDateFromFilterValue(value, 'Week') || {}),
      [FORM_MAP.RANGE_TIME_DIFF]: false,
      timeType: 'Week'
    };
    filterConfirm(obj);
    // 打点，沟通后打点操作放在业务代码的confirm和reset中，不封装在新版本筛选器中
    setBtnPointLog(buttonLogConfig, formatDateFromFilterValue(value, 'Week'));
  }, [filterConfirm]);

  const onReset = useCallback((value) => {
    filterValueRef.current = value;
    const obj = {
      ...(formatDateFromFilterValue(value, 'Week') || {}),
      [FORM_MAP.RANGE_TIME_DIFF]: true,
      timeType: 'Week'
    };
    filterReset(obj);
    // 打点，沟通后打点操作放在业务代码的confirm和reset中，不封装在新版本筛选器中
    setBtnPointLog(buttonLogConfig, formatDateFromFilterValue(value, 'Week'), true);
  }, [filterReset]);

  return <Filter
    config={props.config}
    // useOutInput={true}
    filterHideDefaultIsReq={true}
    pageDefaultSelector={PC_CONSOLE_DEFAULT_FILTER_CONFIG}
    openSticky={openSticky}
    path={path}
    latestDateType={''}
    value={filterValueRef.current}
    inputList={inputList}
    onInit={onInit}
    onConfirm={onConfirm}
    onReset={onReset}
    isHaveFilterSave={isHaveFilterSave}
  >
    {children}
  </Filter>;
};

export default PcConsoleWeeklyFilter;
